import { create } from "zustand";
import type { Product } from "@/types/api";

export type CnhCheckResolution = "confirmed" | "switched-presential" | "canceled";

interface CnhCheckStore {
  open: boolean;
  products: Product[];
  /** Called after the user confirms CNH or switches to presential. */
  callback: ((products: Product[], resolution: CnhCheckResolution) => void) | null;

  request: (
    products: Product[],
    callback: (products: Product[], resolution: CnhCheckResolution) => void
  ) => void;

  close: () => void;
}

/**
 * Global store driving the CNH verification dialog. Pages that trigger a
 * certificate purchase call `request(products, cb)` and wait — the dialog
 * renders mounted at App root, the user picks an option, and the dialog
 * calls back with the final list of products (either the original ones, or
 * the presential equivalents if the user declared they don't have a CNH).
 */
export const useCnhCheckStore = create<CnhCheckStore>((set) => ({
  open: false,
  products: [],
  callback: null,

  request: (products, callback) =>
    set({ open: true, products, callback }),

  close: () =>
    set({ open: false, products: [], callback: null }),
}));
